import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';

import { Grid, Button, Typography, Box } from '@mui/material';

import FlowCard from '../components/availableFlows/FlowCard';

import * as SourceUtils from '../components/availableSources/SourceCardUtil';
import * as TargetUtils from '../components/targets/TargetCardUtil';
import * as ConnectorUtils from '../components/availableConnectorsV2/ConnectorCardUtil';
import * as LinkHelper from '../utils/LinkHelper';

import * as UIAction from '../redux/actions/ui.actions';

import { Alert } from '../components/popupAlerts';
import FireLoading from '../shared/FireLoading';
import Loading from './Loading';
import LoadingDial from '../components/loading/LoadingDial';
import { fetchLinkedSource, fetchSupportedSources } from '../redux/actions';

import { getLocalization } from '../redux/selectors';

const CopyEntity = ({ flow, entity, copyEntities, company, classes }) => {
  const [loading, setLoading] = React.useState(false);
  const isLinking = useSelector((state) => state.entities.isLinking);
  const connectionName = useSelector((state) => state.configuration.connectionName);
  const localization = getLocalization();

  const doCopy = async (f) => {
    setLoading(true);
    try {
      if (entity.entityType === 'connector') {
        await ConnectorUtils.handleDirectLinkConnector({ ...entity, connection_name: connectionName }, { symlink: f });
      } else if (entity.entityType === 'target') {
        await TargetUtils.handleDirectLinkTarget({ ...entity }, { symlink: f });
      } else {
        await SourceUtils.handleDirectLinkSource({ ...entity, connection_name: connectionName }, { symlink: f });
      }

      // TODO: understand why this is here
      if (entity.type === 'oauth' && entity['connect_ui_params'] && entity.entityType !== 'target') return;

      // Refetch the flows
      await LinkHelper.postLink(entity.tenant_id, entity.entityType);
      Alert({ text: `Successfully linked to ${entity.label}`, type: 'success' });
      UIAction.goBack();
    } catch (err) {
      console.error(err);
      Alert({ text: `Failed to link to ${entity.label}: ${err}`, type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const doLink = async () => {
    try {
      UIAction.setIsLinking(true);
      if (entity.entityType === 'connector') {
        ConnectorUtils.doLink({ ...entity, connection_name: connectionName}, undefined, 'goToConfig' );
      } else if (entity.entityType === 'target') {
        TargetUtils.doLink({ ...entity });
      } else {
        SourceUtils.doLink({ ...entity, connection_name: connectionName }, undefined, 'goToConfig');
      }
    } catch (err) {
      console.error(err);
      Alert({ text: `Failed to link to ${entity.label}: ${err}`, type: 'error' });
    }
  };

  return (
    <Box display="flex" flexDirection="column" flex={1} justifyContent="space-between" width="100%">
      {loading || isLinking ? (
        <Box display="flex" flexDirection="column" flex={1} justifyContent="center" alignItems="center" gap={4}>
          <LoadingDial />
        </Box>
      ) : (
        <>
          <Box
            display="flex"
            flexDirection="column"
            position="sticky"
            top={0}
            py={2}
            gap={2}
            sx={{ bgcolor: ({ palette }) => palette.background.paper, zIndex: 10 }}
          >
            <Box component="img" src={entity.icon} width="32px" height="32px" sx={{ objectFit: 'contain' }} />
            <Box display="flex" flexDirection="column" gap={2}>
              <Typography variant="h2">
                {' '}
                {localization?.copySourceScreen?.header || 'Use the same credentials from previous setup?'}{' '}
              </Typography>
            </Box>
          </Box>
          <Box display="flex" flexDirection="column" gap={2} flex={1}>
            {copyEntities
              .filter((f) => f.id !== flow)
              .map((f) => (
                <FlowCard key={f.id} linked={true} {...f} onClick={() => doCopy(f)} />
              ))}
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            width="100%"
            gap={1}
            position="sticky"
            bottom={0}
            py={2}
            zIndex={10}
            bgcolor="background.paper"
          >
            <Button
              fullWidth
              variant="outlined"
              color="text"
              sx={{ opacity: 0.75, py: 1.5 }}
              onClick={doLink}
              disabled={loading}
            >
              {localization?.copySourceScreen?.actionButton || "No, I'll setup a new connection"}
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
};

const mapStateToProps = (state, props) => {
  return {
    entity: state.entities.selectedEntity,
    copyEntities: state.entities.copyEntities,
    flow: state.flows.selectedFlow,
    company: state.preferences.company,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(CopyEntity);
